import React, { useRef } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { getFileType } from "@/utils/fileProcessing/fileTypeUtils";

interface CompactUploadButtonProps {
  onFilesSelected: (files: File[]) => void;
  disabled?: boolean;
}

const CompactUploadButton: React.FC<CompactUploadButtonProps> = ({
  onFilesSelected,
  disabled = false
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    
    if (files.length === 0) return;

    // Validação (mesmo código do DropZone)
    const validFiles: File[] = [];
    const allowedTypes = ["pdf", "png", "jpg", "jpeg", "doc", "txt"];
    const maxFileSize = 20 * 1024 * 1024; // 20MB

    for (const file of files) {
      const fileType = getFileType(file);
      
      if (!fileType || !allowedTypes.includes(fileType)) {
        toast.error(`Arquivo "${file.name}" não é suportado.`);
        continue;
      }
      
      if (file.size > maxFileSize) {
        toast.error(`Arquivo "${file.name}" deve ter menos de 20MB.`);
        continue;
      }
      
      validFiles.push(file);
    }

    if (validFiles.length > 0) {
      onFilesSelected(validFiles);
    }

    // Limpar input para permitir re-upload do mesmo arquivo
    e.target.value = '';
  };

  return (
    <div className="compact-upload-button-wrapper">
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="application/pdf,.pdf,image/png,.png,image/jpeg,.jpg,.jpeg,application/msword,.doc,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx,text/plain,.txt"
        onChange={handleFileChange}
        className="hidden"
        disabled={disabled}
      />
      
      <Button
        onClick={handleClick}
        disabled={disabled}
        variant="outline"
        size="sm"
        className="w-full justify-start gap-2 text-xs h-8 border-dashed hover:border-solid hover:border-primary"
      >
        <Upload className="h-3.5 w-3.5" />
        Adicionar mais arquivos
      </Button>
    </div>
  );
};

export default CompactUploadButton;
